/**
 * Service Icon Slider
 *
 * Kein Autoplay. Features:
 * - Scroll-Progress-Bar (Thumb-Breite = sichtbarer Anteil, Position = Scroll-Fortschritt)
 * - Progress-Bar wird ausgeblendet wenn kein Overflow vorhanden
 */

export function initServiceIconSlider(): void {
    const container = document.getElementById('service-icon-slider') as HTMLElement | null;
    const progress  = document.getElementById('service-icon-slider-progress') as HTMLElement | null;
    const thumb     = document.getElementById('service-icon-slider-thumb') as HTMLElement | null;
    if (!container || !progress || !thumb) return;

    function updateProgress(): void {
        const scrollWidth  = container!.scrollWidth;
        const clientWidth  = container!.clientWidth;
        const maxScroll    = scrollWidth - clientWidth;

        if (maxScroll <= 0) {
            progress!.hidden = true;
            return;
        }

        progress!.hidden = false;

        const thumbWidth    = clientWidth / scrollWidth;          // 0–1
        const thumbPosition = container!.scrollLeft / maxScroll;  // 0–1

        thumb!.style.width = `${thumbWidth * 100}%`;
        thumb!.style.left  = `${thumbPosition * (100 - thumbWidth * 100)}%`;
    }

    container.addEventListener('scroll', updateProgress, { passive: true });

    // Recalculate on resize (visible count changes)
    const resizeObserver = new ResizeObserver(updateProgress);
    resizeObserver.observe(container);

    updateProgress();
}
